import { Head } from '@inertiajs/react'
import type { ReactNode } from 'react'

interface Props {
  message: string
}

function Create({ message }: Props) {
  return (
    <>
      <Head title="Check your phone" />

      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h1 className="text-center text-3xl font-bold text-black">three.pm</h1>
          <h2 className="mt-6 text-center text-2xl text-gray-900">
            Check your phone
          </h2>
          <p className="mt-4 text-center text-gray-600">
            {message}
          </p>
        </div>
      </div>
    </>
  )
}

// Opt out of default layout
Create.layout = (page: ReactNode) => page

export default Create
